import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import TourDatesSection from './components/TourDatesSection';
import StreamingSection from './components/StreamingSection';
import DraftKingsSection from './components/DraftKingsSection';
import LOLNetworkSection from './components/LOLNetworkSection';
import HartbeatSection from './components/HartbeatSection';
import HartbeatVenturesSection from './components/HartbeatVenturesSection';
import Footer from './components/Footer';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import ProductDetail from './pages/ProductDetail';
import StreamingDetail from './pages/StreamingDetail';
import { Toaster } from './components/ui/toaster';

const HomePage = () => {
  return (
    <>
      <Navigation />
      <HeroSection />
      <TourDatesSection />
      <StreamingSection />
      <DraftKingsSection />
      <LOLNetworkSection />
      <HartbeatSection />
      <HartbeatVenturesSection />
      <Footer />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/streaming/:id" element={<StreamingDetail />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;